<template>
  <div class="modal-content">
    <div class="viewer_box" ref="imgViewerBox">
      <v-row v-resize="imgResize">
        <div class="img"><img src="" alt=""  /></div>
      </v-row>
    </div>
	</div>
</template>

<script>
export default {
	props: [
		'fileInfo'
  ],
  mounted() {
    let imageElement = this.$el.querySelector(".modal-content .viewer_box .img img");
    if(imageElement) {
      this.loadImage(imageElement);
    }
  },
  methods: {
    loadImage(img) {
      let obj = this;
      let fncLoadImage = function() {
        if (obj.fileInfo.groupId) {
          let imageURI =
            "/api/cofile/paper/imageViewer?groupId=" +
            obj.fileInfo.groupId +
            "&paperId=" +
            obj.fileInfo.locationId +
            "&fileId=" +
            obj.fileInfo.fileId;
          let xhr = new XMLHttpRequest();
          xhr.onreadystatechange = function() {
            if (xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {
              img.src = URL.createObjectURL(xhr.response);
              img.onload = function() {
                let maxWidth = obj.$refs.imgViewerBox.offsetWidth;
                let maxHeight = obj.$refs.imgViewerBox.offsetHeight;
                let imgWidth = img.naturalWidth;
                let imgHeight = img.naturalHeight;
                let scaleX = maxWidth / imgWidth;
                let scaleY = maxHeight / imgHeight;

                let scale = (scaleX < scaleY) ? scaleX : scaleY;
                if(scale > 1) {
                  scale = 1;
                }

                obj.$el.querySelector(".modal-content .viewer_box .img").style.width = (imgWidth * scale) + 'px';
                obj.$el.querySelector(".modal-content .viewer_box .img").style.height = (imgHeight * scale) + 'px';
              }
            }
          };
          xhr.open("GET", imageURI, true);
          var token = localStorage.getItem("Authorization");
          xhr.setRequestHeader("Authorization", token);
          xhr.responseType = "blob";
          xhr.send();
        } else {
          setTimeout(fncLoadImage, 500);
        }
      };
      setTimeout(fncLoadImage, 1);
    },
    imgResize() {
      let obj = this;
      let imageElement = obj.$el.querySelector(".modal-content .viewer_box .img img");
      let maxWidth =obj.$refs.imgViewerBox.offsetWidth;
      let maxHeight = obj.$refs.imgViewerBox.offsetHeight;
      let imgWidth = imageElement.naturalWidth;
      let imgHeight = imageElement.naturalHeight;
      let scaleX = maxWidth / imgWidth;
      let scaleY = maxHeight / imgHeight;
                
      let scale = (scaleX < scaleY) ? scaleX : scaleY;
      if(scale > 1) {
        scale = 1;
      }

      obj.$el.querySelector(".modal-content .viewer_box .img").style.width = (imgWidth * scale) + 'px';
      obj.$el.querySelector(".modal-content .viewer_box .img").style.height = (imgHeight * scale) + 'px';
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/file/viewer/detail/ViewerImage.vue